var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E67B3A",
    d: "M769,765.4c91.3-38.4,148.9-86.5,221-158.5L10,633.3l19.2,115.3c4.8,26.4,26.4,48,60,48h506.8C656.1,794.2,718.6,787,769,765.4L769,765.4z M817.1,496.4h129.7v69.7l-129.7,4.8V496.4L817.1,496.4z M656.1,385.9h129.7v93.7H656.1V385.9L656.1,385.9z M656.1,496.4h129.7v74.5l-129.7,4.8V496.4L656.1,496.4z M495.2,385.9h129.7v93.7H495.2V385.9L495.2,385.9z M495.2,496.4h129.7v79.3l-129.7,4.8V496.4L495.2,496.4z M41.2,496.4h129.7v91.3l-86.5,2.4H41.2V496.4L41.2,496.4z M303,385.9h163.3v192.2l-266.6,7.2V383.5V203.4H303V385.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerShip);
export default __webpack_public_path__ + "static/media/container-ship.3ab3db48fc4ef35161163f1a1ab9fe65.svg";
export { ForwardRef as ReactComponent };